import makeRepayment from '../las/makeRepayment';
import openDashboard from '../las/openDashboard';
import triggerLoanJourney from '../las/triggerLoanJourney';
import { injectLasDnsPrefetch, setupAskOriginResponse } from '../las/utils';
import { injectLoaderFrame } from '../las/utils/loader';
import withdrawPrincipal from '../las/withdrawPrincipal';
import { sentry } from '../services/sentry';
import { store } from '../utils/userStore';

class ScLoan {
  // eslint-disable-next-line no-use-before-define
  private static _lasSdkInstance: ScLoan;

  constructor({ gatewayName, e }) {
    if (ScLoan._lasSdkInstance !== undefined) {
      // eslint-disable-next-line no-console
      console.warn(
        "this SDK follows Singleton Pattern, thus doesn't allow creation of multiple instances and if the constructor is called multiple times, the first instance is returned each time.",
      );
      // eslint-disable-next-line no-constructor-return
      return ScLoan._lasSdkInstance;
    }
    ScLoan._lasSdkInstance = this;
    store.loanGateway = gatewayName;
    sentry.loan.init(gatewayName);
    if (e) {
      store.loanEnv = e;
    }
    setupAskOriginResponse();
    injectLasDnsPrefetch();
    // inject the loader frame upfront so the first showLoader is instant
    injectLoaderFrame();
  }
}

interface ScLoan {
  apply: typeof triggerLoanJourney;
  pay: typeof makeRepayment;
  withdraw: typeof withdrawPrincipal;
  service: typeof openDashboard;
}

ScLoan.prototype.apply = triggerLoanJourney;
ScLoan.prototype.pay = makeRepayment;
ScLoan.prototype.withdraw = withdrawPrincipal;
ScLoan.prototype.service = openDashboard;

export default ScLoan;
